import { useEffect, useState } from 'react';

interface BubbleProps {
  onOpen: () => void;
  label: string;
  preview?: string;
}

/**
 * Standard chat launcher: round circle, solid brand color, white filled
 * chat icon (slightly rotated for visual interest). Color is controlled
 * from admin via Settings → Widget → Launcher color.
 */
export function Bubble({ onOpen, label, preview }: BubbleProps) {
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    if (!preview) return;
    if (sessionStorage.getItem('grippy:preview-shown') === '1') return;

    const inTimer = setTimeout(() => setShowPreview(true), 2500);
    const outTimer = setTimeout(() => {
      setShowPreview(false);
      sessionStorage.setItem('grippy:preview-shown', '1');
    }, 14000);

    return () => {
      clearTimeout(inTimer);
      clearTimeout(outTimer);
    };
  }, [preview]);

  const dismissPreview = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowPreview(false);
    sessionStorage.setItem('grippy:preview-shown', '1');
  };

  return (
    <>
      {showPreview && preview && (
        <div className="g-preview" role="dialog" aria-label="Assistant preview">
          <button
            type="button"
            className="g-preview__close"
            onClick={dismissPreview}
            aria-label="Dismiss preview"
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
          <button type="button" className="g-preview__body" onClick={onOpen}>
            {preview}
          </button>
        </div>
      )}
      <button type="button" className="g-launcher" onClick={onOpen} aria-label={label}>
        <svg
          className="g-launcher__icon"
          viewBox="0 0 32 32"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          {/* Body PERFECTLY centered in viewBox (body y=8-24, midpoint 16).
              Small tail below. Optical and geometric center now match. */}
          <path d="M6 8 H26 C27.1 8 28 8.9 28 10 V22 C28 23.1 27.1 24 26 24 H14 L9 28 V24 H6 C4.9 24 4 23.1 4 22 V10 C4 8.9 4.9 8 6 8 Z" />
        </svg>
      </button>
    </>
  );
}
